<template>
    <div id="container-card" :class="[styleType == 'photo' ? [styleType, ['lg:fundator-desk', 'max-lg:fundator-tablet', 'max-sm:fundator-movil']] : styleType]" class="flex max-md:flex-col shadow-card shadow-black-12 h-full rounded-smoth relative">
        <div id="body-card" :class="[dataType == 'fundator-data' ? ['lg:w-photo-desk', 'max-lg:w-photo-tablet', 'max-sm:w-full'] : '']" class="p-special relative">
            <div id="title-card">
                <span :class="[dataType == 'fundator-data' ? ['text-title-fundator-desktop', 'max-md:text-title-fundator-mobile', 'text-primary-text'] : ['text-principal-desktop', 'max-md:text-principal-mobile']]" class="font-bloggerB dark:text-primary-dark-text">
                    {{ config['title'] }}
                </span>
            </div>
            <div id="text-card" class="mt-text font-monserratM text-content-desktop leading-6 max-md:text-content-mobile dark:text-primary-dark-text">
                <span>
                    {{ config['text'] }}
                </span>
            </div>
            <div v-if="styleType != 'photo'" id="button-card" class="mt-special">
                <ButtonV :text-button="data[0]" type="primary" :direction="to[0]" />
            </div>
        </div>
        <div v-if="styleType == 'photo'" id="container-photo" class="max-sm:aspect-square flex justify-center shrink-0 relative">
        </div>
    </div>
</template>

<script setup>
import { ref, watchEffect } from 'vue'
import { useTranslation } from 'i18next-vue';
import ButtonV from './Button.vue'


const props = defineProps([
    'dataType',
    'styleType',
    'dataJson'
])

const { t } = useTranslation();

var to = props.dataType.split("-")
var config = ref({})

var data = ref([
    t('buttons', { returnObjects: true })[props['dataType'] + '-button']
])

watchEffect(()=>{
    if(props.dataJson){
        config.value = props.dataJson[props.dataType]
    }
})
</script>